module.exports = __webpack_public_path__ + "static/media/ajax-loader.aee4facb.gif";